import { useEffect } from 'react';
import { logger } from '@/services/logger.service';
import { IListSettings } from '@/stores/SettingsStore';

export const useNotification = ({
  setSettings,
}: {
  setSettings: (list: Partial<IListSettings>) => void;
}) => {
  useEffect(() => {
    if (!('Notification' in window)) {
      logger.warn(
        '[Browser Notification] Browser does not support desktop notification',
      );
    } else {
      Notification.requestPermission().then(
        (result: NotificationPermission) => {
          logger.log(
            `[Browser Notification] Status of notifications is ${result}`,
          );

          if (setSettings && Notification?.permission !== 'granted') {
            setSettings({
              notification: { inboundCall: false, incomingMessage: false },
            });
          }
        },
      );
    }
  }, []);
};
